"use client"
import { usePathname } from "next/navigation"
import * as React from "react"

declare global {
  interface Window {
    HubSpotConversations?:
      | undefined
      | {
          widget: {
            load: () => void
            remove: () => void
          }
        }
  }
}

const BLOCKED_PATHS = ["admin", "trendbaby", "register", "login", "invoices", "payment-required", "invitation"]

export function HubspotChat() {
  const pathname = usePathname()

  React.useEffect(() => {
    try {
      if (!pathname) return
      if (BLOCKED_PATHS.some((p) => pathname?.includes(p))) {
        window.HubSpotConversations?.widget?.remove()
      } else {
        window.HubSpotConversations?.widget?.load()
      }
    } catch (error) {
      console.log(error)
    }
  }, [pathname])

  return null
}
